<div class="row">
  <div class="col-xs-12 col-sm-12">
    <app-carousel [slides]="slides" [autoAdvanceMs]="4000"></app-carousel>
  </div>
</div>
<div class="row text-center no-margin" *ngIf="themeService.currentTheme !== 'default'">
  <div class="col-xs-12 col-md-12">
    <h2>Seasonal Items</h2>
  </div>
  <div class="col-xs">
    <div class="row no-margin">
      <div class="col-xs-6 col-sm-3" *ngFor="let item of helpService.themeItems; let i = index">
        <nb-tag appearance="outline" [text]="item" status="primary"> </nb-tag>
      </div>
    </div>
    <br />
    <br />
    <a [href]="helpService.themeGalleryURL">
      <button nbButton status="primary" size="giant">
        <nb-icon icon="grid"></nb-icon>
        Go To Gallery
      </button>
    </a>
  </div>
  <div *ngIf="themeService.currentTheme === 'winter'" class="iframe-wrapper">
    <iframe
      title="winter video"
      name="winter-video"
      class="responsive-iframe"
      src="https://www.youtube.com/embed/UtcBX2Vu4NY"
    ></iframe>
  </div>
</div>
<div class="row">
  <div class="col-md-12 text-center col-full">
    <p class="h1 shop-title" routerLink="/shop/collection/mulch soil and stone/category/bulk-mulch">
      Shop Online
    </p>
  </div>
</div>
<div class="row text-center middle-xs">
  <div class="col-xs-12 col-sm-6">
    <div routerLink="/shop/collection/mulch soil and stone/category/bulk-mulch">
      <nb-icon class="section-icon" status="primary" icon="car-outline"></nb-icon>
    </div>
    <button
      shape="round"
      routerLink="/shop/collection/mulch soil and stone"
      status="primary"
      size="giant"
      nbButton
    >
      Order Bulk Delivery
    </button>
    <p>
      Schedule mulch for delivery at your convenience!
      <br />
      Skip the call or visit and order online today.
    </p>
  </div>
  <div class="col-xs-12 col-sm-6">
    <div routerLink="/giftcards">
      <nb-icon class="section-icon" status="primary" icon="gift-outline"></nb-icon>
    </div>
    <button shape="round" routerLink="/giftcards" status="primary" size="giant" nbButton>
      Shop Gift Cards
    </button>
    <p>
      Order your gift card online.
      <br />
      Digital Delivery Immediately.
    </p>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <h2>Recommended For You</h2>
  </div>
</div>
<div class="row text-center">
  <div class="col-xs-12 col-sm-4 col-md-4" routerLink="/specials">
    <img alt="specials" class="icon-scale" src="assets/images/sales.svg" />
    <div class="section-subtitle h6">Weekly Specials</div>
  </div>
  <div class="col-xs-12 col-sm-4 col-md-4">
    <a routerLink="/inventory">
      <img alt="plants" class="icon-scale" src="assets/images/trees.svg" />
    </a>
    <div class="section-subtitle h6">Popular In-Stock Items</div>
  </div>
  <div class="col-xs-12 col-sm-4 col-md-4" routerLink="/contact/faq">
    <img alt="help" class="icon-scale" src="assets/images/contact.svg" />
    <div class="section-subtitle h6">Get Help</div>
  </div>
</div>
<div class="row">
  <div class="col-md-12 text-right col-full">
    <h2>Popular Gardening Information</h2>
  </div>
</div>
<div class="row text-center">
  <div class="col-xs-12 col-sm-4 col-md-4">
    <a routerLink="/gallery">
      <img alt="gallery" class="icon-scale" src="assets/images/gallery.svg" />
    </a>
    <div class="section-subtitle h6">Gallery</div>
  </div>
  <div class="col-xs-12 col-sm-4 col-md-4" routerLink="/design">
    <img alt="design" class="icon-scale" src="assets/images/design.svg" />
    <div class="section-subtitle h6">Design Service</div>
  </div>
  <div class="col-xs-12 col-sm-4 col-md-4" routerLink="/resources/calculators/mulch">
    <img alt="mulch-calculator" class="icon-scale" src="assets/images/calc.svg" />
    <div class="section-subtitle h6">Mulch Calculator</div>
  </div>
</div>
<div class="row">
  <div class="col-md-12 col-full">
    <h2>See What's Going On At The Garden Center</h2>
  </div>
</div>
<div class="row">
  <div class="col-md-12 col-full">
    <app-connect-link></app-connect-link>
  </div>
</div>
<div class="row text-center middle-sm" *ngIf="isBrowser">
  <ng-container *ngFor="let post of instagramPosts; let i = index">
    <div *ngIf="i < 6" class="col-xs-12 col-sm-4 col-full container">
      <video
        [muted]="true"
        controls
        playsinline
        autoPlay
        loop
        *ngIf="post.media_type.indexOf('VIDEO') > -1"
        class="img-responsive"
        loading="lazy"
      >
        <source [src]="post.media_url" />
      </video>
      <img
        loading="lazy"
        class="img-responsive"
        *ngIf="post.media_type.indexOf('VIDEO') < 0"
        [src]="post.media_url || 'assets/images/missing_photo.jpg'"
      />
      <div class="middle-backdrop"></div>
      <div class="middle">
        <div class="text">
          <strong>{{
            post?.caption?.length > 120 ? (post.caption | slice : 0 : 120) + '..' : post.caption
          }}</strong>
        </div>
        <br />
        <a [href]="post.permalink" target="_blank">
          <button class="middle-btn" nbButton size="small" shape="round" status="primary">
            Learn More
          </button>
        </a>
      </div>
    </div>
  </ng-container>
</div>
<div class="row text-center">
  <div class="col-md-12">
    <h2>We get you <i>Ready To Grow!</i></h2>
  </div>
</div>
<div class="row">
  <div class="col-xs-12 col-sm-6 col-md-6 col-full">
    <div class="iframe-wrapper">
      <iframe
        loading="lazy"
        title="russells aerial"
        class="responsive-iframe"
        src="https://www.youtube.com/embed/RFchsivtVfI"
      ></iframe>
    </div>
  </div>
  <div class="col-xs-12 col-sm-6 col-md-6 col-full text-right">
    <nb-icon class="icon-scale" icon="star" status="warning"></nb-icon>
    <nb-icon class="icon-scale" icon="star" status="warning"></nb-icon>
    <nb-icon class="icon-scale" icon="star" status="warning"></nb-icon>
    <nb-icon class="icon-scale" icon="star" status="warning"></nb-icon>
    <nb-icon class="icon-scale" icon="star" status="warning"></nb-icon>

    <blockquote>
      <p class="subtitle">
        I am completely clueless when it comes to gardening but when we were there (Russell's) this
        last weekend, Heidi came to the rescue! She helped pick out beautiful perennials and even
        drew a helpful diagram! No other place has done this. This is why we go there year round
        (they have beautiful Christmas trees as well!) I highly recommend Russell's!
      </p>
      <footer>Kerri - Facebook Customer</footer>
    </blockquote>
  </div>
</div>
<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-12 col-full">
    <div class="iframe-wrapper">
      <iframe
        loading="lazy"
        title="welcome video"
        class="responsive-iframe"
        src="https://www.youtube.com/embed/_ZP6I4NqYfg"
      ></iframe>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-12 col-full col-social">
    <app-connect-link></app-connect-link>
  </div>
</div>
